import { Button, Card, message, Select } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../../components/Footer';
import { Header } from '../../components/Header';
import { apiNode } from '../../services/api';
import { Card as CustomCard } from './components/Card';
import { DeleteLeagueModal } from './components/DeleteLeagueModal';
import { KickPlayerModal } from './components/KickPlayerModal';
import {
  ButtonContainer,
  Container,
  Content,
  LeagueInfo,
  Users,
} from './styles';

interface LeagueProps {
  liga: {
    id: number;
    nome: string;
    privada: boolean;
  };
  participante: {
    isAdmin: boolean;
  };
}

interface ParticipantsProps {
  id: number;
  pontos: number;
  username: string;
  foto: string;
  isAdmin: boolean;
}

export const LeagueSettings = () => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [isSaveButtonLoading, setIsSaveButtonLoading] = useState(false);
  const [isPrivate, setIsPrivate] = useState(false);

  const [isKickPlayerModalOpen, setIsKickPlayerModalOpen] = useState(false);
  const [isDeleteLeagueModalOpen, setIsDeleteLeagueModalOpen] = useState(false);

  const [league, setLeague] = useState<LeagueProps>({} as LeagueProps);
  const [leagueName, setLeagueName] = useState(league.liga?.nome);

  const [participants, setParticipants] = useState<ParticipantsProps[]>([]);
  const [selectedParticipant, setSelectedParticipant] =
    useState<ParticipantsProps>({} as ParticipantsProps);

  useEffect(() => {
    try {
      setIsLoading(true);
      const getLeague = async () => {
        const leagueResponse = await apiNode
          .get<LeagueProps>('/ligas/users')
          .catch(() => {
            navigate('/leagues');
          });

        if (leagueResponse) {
          const { id } = leagueResponse.data.liga;
          const { isAdmin } = leagueResponse.data.participante;

          if (!isAdmin) {
            navigate('/leagues');
            return;
          }

          const participantsResponse = await apiNode.get(`/ligas/${id}`);

          setParticipants(participantsResponse.data.liga.participantes_ligas);
          setLeague(leagueResponse.data);
          setIsPrivate(leagueResponse.data.liga.privada);
          setIsLoading(false);
        }
      };

      getLeague();
    } catch (err) {
      console.log(err);
      setIsLoading(false);
    }
  }, [navigate]);

  const handleSaveEditLeague = async () => {
    try {
      setIsSaveButtonLoading(true);

      if (leagueName === '' || !league.participante.isAdmin) {
        setIsSaveButtonLoading(false);
        return;
      }

      await apiNode.put(`/ligas/${league.liga.id}`, {
        nome: leagueName,
        privada: isPrivate,
      });

      message.success('Alteração salva com sucesso!');
      setIsSaveButtonLoading(false);
    } catch (err) {
      console.log(err);
      setIsSaveButtonLoading(false);
    }
  };

  const updateParticipantsList = (id: number) => {
    let newParticipantsList: ParticipantsProps[] = [];

    participants.forEach((participant) => {
      if (participant.id !== id) {
        newParticipantsList.push(participant);
      }
    });

    setParticipants(newParticipantsList);
  };

  const openKickPlayerModal = (participant: ParticipantsProps) => {
    setIsKickPlayerModalOpen(true);
    setSelectedParticipant(participant);
  };

  return (
    <Container>
      <Header />
      <Content>
        <h1>Gerenciar Liga</h1>
        <div>
          <LeagueInfo>
            <span>
              <fieldset>
                <legend>Nome</legend>
                <input
                  type="text"
                  name="name"
                  defaultValue={league && league.liga?.nome}
                  onChange={(event) => setLeagueName(event.target.value)}
                />
              </fieldset>
              <div>
                <p>Status:</p>
                <Select
                  onChange={() => setIsPrivate(!isPrivate)}
                  value={
                    isLoading ? 'Selecione' : isPrivate ? 'private' : 'public'
                  }
                  disabled={isLoading}
                >
                  <Select.Option key="public" style={{ fontSize: 20 }}>
                    Pública
                  </Select.Option>
                  <Select.Option key="private" style={{ fontSize: 20 }}>
                    Privada
                  </Select.Option>
                </Select>
              </div>
            </span>
            <ButtonContainer>
              <Button
                onClick={handleSaveEditLeague}
                loading={isSaveButtonLoading}
              >
                Salvar
              </Button>
              <Button
                onClick={() => setIsDeleteLeagueModalOpen(true)}
                disabled={isSaveButtonLoading}
              >
                Deletar Liga
              </Button>
            </ButtonContainer>
          </LeagueInfo>
          <Users>
            <h1>Jogadores</h1>

            <div>
              {isLoading && (
                <>
                  <Card
                    loading={true}
                    style={{ width: '40%', marginBottom: 36, marginRight: 36 }}
                  />
                  <Card
                    loading={true}
                    style={{ width: '40%', marginBottom: 36 }}
                  />
                  <Card
                    loading={true}
                    style={{ width: '40%', marginBottom: 36, marginRight: 36 }}
                  />
                  <Card
                    loading={true}
                    style={{ width: '40%', marginBottom: 36 }}
                  />
                </>
              )}
              {!isLoading &&
                participants.map((participant) => (
                  <>
                    <CustomCard
                      participant={participant}
                      key={participant.id}
                      openKickPlayerModal={openKickPlayerModal}
                    />
                  </>
                ))}
            </div>
          </Users>
        </div>
      </Content>
      <Footer />
      <KickPlayerModal
        closeModal={() => setIsKickPlayerModalOpen(false)}
        isOpen={isKickPlayerModalOpen}
        participant={selectedParticipant}
        updateParticipantsList={updateParticipantsList}
      />

      <DeleteLeagueModal
        closeModal={() => setIsDeleteLeagueModalOpen(false)}
        isOpen={isDeleteLeagueModalOpen}
      />
    </Container>
  );
};
